module.exports = __webpack_public_path__ + "static/media/krx-derivatives-seeds-03.1be18a72.jpg";